module.exports = __webpack_public_path__ + "static/media/PedestrianRoutePastWorks.d0e1a582.pdf";